import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	addToStarred: {
		id: 'platform.ui.favouriting.favourite-button-stateless.add-to-starred',
		defaultMessage: 'Add to Starred',
		description:
			"Tooltip for button to mark item (board, project, issue, filter or dashboard) as favourite. Button is shown in the header of an item's page",
	},
	removeFromStarred: {
		id: 'platform.ui.favouriting.favourite-button-stateless.remove-from-starred',
		defaultMessage: 'Remove from Starred',
		description:
			'Tooltip for button to unmark item as favourite. This is the same button as the one with "software.main.header.star-button.star-button" text. Current text is shown when item is marked as favourite.',
	},
	toggleStarred: {
		id: 'platform.ui.favouriting.favourite-button-stateless.toggle-starred',
		defaultMessage: 'Star',
		description:
			'aria-label text as a verb for button to toggle favourite state of an item (board, project, issue, filter or dashboard) without specifying the item name.',
	},
	toggleStarredWithItemName: {
		id: 'platform.ui.favouriting.favourite-button-stateless.toggle-starred-with-item-name',
		defaultMessage: 'Star {itemName}',
		description:
			'aria-label text as a verb for button to toggle favourite state of the item (board, project, issue, filter or dashboard).',
	},
});
